<template>
	<div class="admin-resourcer">
		<AppTextButton
			class="admin-resourcer__btn"
			:text="isOpen ? 'CLOSE' : 'ADMIN'"
			:fontSize="12"
			@click="isOpen = !isOpen"
		/>
		<div
			v-if="isOpen"
			class="admin-resourcer__content"
			:class="{ 'admin-resourcer__content--open': isOpen }"
		>
			<div class="stats">
				Stats:
				<div>Golden eggs spawnrate: {{ goldenEggsSpawn }}%</div>
			</div>
			<div class="buttons">
				<button type="button" @click="ticker.start()">
					▶️ Ticker on
				</button>
				<button type="button" @click="ticker.stop()">
					⏸️ Ticker off
				</button>
			</div>
			<div class="buttons">
				<button type="button" @click="onTick">⏩ Tick</button>
				<button type="button" @click="onTick6">⏭️ 6 Ticks</button>
			</div>
			<div class="buttons">
				<button type="button" @click="clearInventory">
					<span>Clear Inventory</span>
				</button>
				<button type="button" @click="resetAllResources">
					<span>Set all to 0</span>
				</button>
				<button
					type="button"
					@click="set(ResourceType.COINS, 0, 'admin cheat')"
				>
					<span>Set to 0</span>
					<AppMainIcon
						:iconName="ResourceType.COINS"
						:iconSize="16"
					/>
				</button>
				<button
					type="button"
					@click="increase(ResourceType.GEMS, 1_000, 'admin cheat')"
				>
					<span>+ 1<strong>K</strong></span>
					<AppMainIcon :iconName="ResourceType.GEMS" :iconSize="16" />
				</button>
				<button
					type="button"
					@click="
						increase(
							ResourceType.COINS,
							100_000_000_000,
							'admin cheat',
						)
					"
				>
					<span>+ 100<strong>B</strong></span>
					<AppMainIcon
						:iconName="ResourceType.COINS"
						:iconSize="16"
					/>
				</button>
				<button
					type="button"
					@click="
						increase(ResourceType.LUMBER, 1_000_000, 'admin cheat')
					"
				>
					<span>+ 1<strong>M</strong></span>
					<AppMainIcon
						:iconName="ResourceType.LUMBER"
						:iconSize="16"
					/>
				</button>
				<button
					type="button"
					@click="
						increase(ResourceType.STONE, 1_000_000, 'admin cheat')
					"
				>
					<span>+ 1<strong>M</strong></span>
					<AppMainIcon
						:iconName="ResourceType.STONE"
						:iconSize="16"
					/>
				</button>
				<button
					type="button"
					@click="
						increase(ResourceType.CLAY, 1_000_000, 'admin cheat')
					"
				>
					<span>+ 1<strong>M</strong></span>
					<AppMainIcon :iconName="ResourceType.CLAY" :iconSize="16" />
				</button>
				<button
					type="button"
					@click="
						increase(ResourceType.IRON, 1_000_000, 'admin cheat')
					"
				>
					<span>+ 1<strong>M</strong></span>
					<AppMainIcon :iconName="ResourceType.IRON" :iconSize="16" />
				</button>
				<button
					type="button"
					@click="
						increase(ResourceType.GOODS, 1_000_000, 'admin cheat')
					"
				>
					<span>+ 1<strong>M</strong></span>
					<AppMainIcon
						:iconName="ResourceType.GOODS"
						:iconSize="16"
					/>
				</button>
				<button
					type="button"
					@click="
						increase(ResourceType.STEEL, 1_000_000, 'admin cheat')
					"
				>
					<span>+ 1<strong>M</strong></span>
					<AppMainIcon
						:iconName="ResourceType.STEEL"
						:iconSize="16"
					/>
				</button>
				<button
					type="button"
					@click="
						increase(ResourceType.ARMY, 1_000_000, 'admin cheat')
					"
				>
					<span>+ 1<strong>M</strong></span>
					<AppMainIcon :iconName="ResourceType.ARMY" :iconSize="16" />
				</button>
				<button
					type="button"
					@click="
						increase(ResourceType.RATIONS, 1_000_000, 'admin cheat')
					"
				>
					<span>+ 1<strong>M</strong></span>
					<AppMainIcon
						:iconName="ResourceType.RATIONS"
						:iconSize="16"
					/>
				</button>
				<button
					type="button"
					@click="
						increase(
							ResourceType.EVENTIUM,
							1_000_000,
							'admin cheat',
						)
					"
				>
					<span>+ 1<strong>M</strong></span>
					<AppMainIcon
						:iconName="ResourceType.EVENTIUM"
						:iconSize="16"
					/>
				</button>
			</div>
			<div class="buttons">
				<button type="button" @click="testStoryFinish">
					Test story finish
				</button>
			</div>
			<div class="buttons">
				<button type="button" @click="testStoryStart">
					Test story start
				</button>
			</div>
			<div class="buttons">
				<button type="button" @click="incrementExplorationSpeed">
					<span>+ 100</span>
					<AppMainIcon
						class="exploration-box__icon"
						:iconName="ResourceType.EXPLORATION_SPEED"
						:iconSize="16"
					/>
				</button>
				<button type="button" @click="decrementExplorationSpeed">
					<span>- 100</span>
					<AppMainIcon
						class="exploration-box__icon"
						:iconName="ResourceType.EXPLORATION_SPEED"
						:iconSize="16"
					/>
				</button>
			</div>
			<div class="buttons">
				<button
					type="button"
					@click="
						buildingsStorageStore.increase(
							FrameName.SILVER_MINE,
							1,
							'admin cheat',
						)
					"
				>
					+1 Silver Mine
				</button>
				<button
					type="button"
					@click="
						buildingsStorageStore.increase(
							FrameName.SHALLOW_SEA_ROCKS_LIGHTHOUSE,
							1,
							'admin cheat',
						)
					"
				>
					+1 Lighthouse
				</button>
				<button
					type="button"
					@click="
						buildingsStorageStore.increase(
							FrameName.COUNTRY_HOUSE,
							1,
							'admin cheat',
						)
					"
				>
					+1 Country House
				</button>
				<button
					type="button"
					@click="
						buildingsStorageStore.increase(
							FrameName.PUMPKIN_FARM,
							1,
							'admin cheat',
						)
					"
				>
					+1 Pumpkin Farm
				</button>
				<button
					type="button"
					@click="
						buildingsStorageStore.increase(
							FrameName.BIG_SHIPYARD,
							1,
							'admin cheat',
						)
					"
				>
					+1 Big Shipyard
				</button>
				<button
					type="button"
					@click="
						buildingsStorageStore.increase(
							FrameName.FISHERMANS_HUT,
							1,
							'admin cheat',
						)
					"
				>
					+1 Fishermans Hut
				</button>
				<button
					type="button"
					@click="
						buildingsStorageStore.increase(
							FrameName.FISHING_VILLAGE,
							1,
							'admin cheat',
						)
					"
				>
					+1 Fishing Village
				</button>
				<button
					type="button"
					@click="
						buildingsStorageStore.increase(
							FrameName.SCULPTOR,
							1,
							'admin cheat',
						)
					"
				>
					+1 Sculptor
				</button>
				<button
					type="button"
					@click="
						buildingsStorageStore.increase(
							FrameName.ROOF_TILE_FACTORY,
							1,
							'admin cheat',
						)
					"
				>
					+1 Roof Tile Factory
				</button>
				<button
					type="button"
					@click="
						buildingsStorageStore.increase(
							FrameName.SEAWEED_FARM,
							1,
							'admin cheat',
						)
					"
				>
					+1 Seaweed Farm
				</button>
				<button
					type="button"
					@click="
						buildingsStorageStore.increase(
							FrameName.TURKEY_FARM,
							1,
							'admin cheat',
						)
					"
				>
					+1 Turkey Farm
				</button>
				<button
					type="button"
					@click="
						buildingsStorageStore.increase(
							FrameName.MINT,
							1,
							'admin cheat',
						)
					"
				>
					+1 Mint
				</button>
				<button
					type="button"
					@click="
						buildingsStorageStore.increase(
							FrameName.BANQUET,
							1,
							'admin cheat',
						)
					"
				>
					+1 Banquet
				</button>
				<button
					type="button"
					@click="
						buildingsStorageStore.increase(
							FrameName.MINSTRELS_PODIUM,
							1,
							'admin cheat',
						)
					"
				>
					+1 Minstrels Podium
				</button>
				<button
					type="button"
					@click="
						buildingsStorageStore.increase(
							FrameName.MONOLITH_CIRCLE,
							1,
							'admin cheat',
						)
					"
				>
					+1 Monolith Circle
				</button>
				<button
					type="button"
					@click="
						buildingsStorageStore.increase(
							FrameName.DARKWOOD_LUMBER_MILL,
							1,
							'admin cheat',
						)
					"
				>
					+1 Darkwood Lumber Mill
				</button>
				<button
					type="button"
					@click="
						buildingsStorageStore.increase(
							FrameName.TOYMAKERS_WORKSHOP,
							1,
							'admin cheat',
						)
					"
				>
					+1 Toymaker's Workshop
				</button>
				<button
					type="button"
					@click="
						buildingsStorageStore.increase(
							FrameName.RAFT,
							1,
							'admin cheat',
						)
					"
				>
					+1 Raft
				</button>
				<button
					type="button"
					@click="
						buildingsStorageStore.increase(
							FrameName.BOTTLETRAP,
							1,
							'admin cheat',
						)
					"
				>
					+1 Bottle Trap
				</button>
				<button
					type="button"
					@click="
						buildingsStorageStore.increase(
							FrameName.FORTRESS,
							1,
							'admin cheat',
						)
					"
				>
					+1 Fortress
				</button>
				<button
					type="button"
					@click="
						buildingsStorageStore.increase(
							FrameName.RABBIT_FARM,
							1,
							'admin cheat',
						)
					"
				>
					+1 Rabbit Farm
				</button>
				<button
					type="button"
					@click="
						buildingsStorageStore.increase(
							FrameName.LUCKY_CAULDRON,
							1,
							'admin cheat',
						)
					"
				>
					+1 Lucky Cauldron
				</button>
				<button
					type="button"
					@click="
						buildingsStorageStore.increase(
							FrameName.HILLS_BLAST_FURNACE,
							1,
							'admin cheat',
						)
					"
				>
					+1 Blast Furnace
				</button>
				<button
					type="button"
					@click="
						buildingsStorageStore.increase(
							FrameName.STORAGE_OVERSEER,
							1,
							'admin cheat',
						)
					"
				>
					+1 Storage Overseer
				</button>
				<button
					type="button"
					@click="
						buildingsStorageStore.increase(
							FrameName.ARMAMENTS_TRADER,
							1,
							'admin cheat',
						)
					"
				>
					+1 Armaments Trader
				</button>
				<button
					type="button"
					@click="
						buildingsStorageStore.increase(
							FrameName.HILLS_LOOKOUT_TOWER,
							1,
							'admin cheat',
						)
					"
				>
					+1 Lookout Tower
				</button>
				<button
					type="button"
					@click="
						buildingsStorageStore.increase(
							FrameName.PEA_PATCH,
							1,
							'admin cheat',
						)
					"
				>
					+1 Pea Patch
				</button>
				<button
					type="button"
					@click="
						buildingsStorageStore.increase(
							FrameName.MANOR,
							1,
							'admin cheat',
						)
					"
				>
					+1 Manor
				</button>
				<button
					type="button"
					@click="
						buildingsStorageStore.increase(
							FrameName.LARGE_BREWERY,
							1,
							'admin cheat',
						)
					"
				>
					+1 Large Brewery
				</button>
				<button
					type="button"
					@click="
						buildingsStorageStore.increase(
							FrameName.ENKINDLED_HOUSEHOLD,
							1,
							'admin cheat',
						)
					"
				>
					+1 Enkindled Household
				</button>
				<button
					type="button"
					@click="
						buildingsStorageStore.increase(
							FrameName.FIRE_FESTIVAL_PYRE,
							1,
							'admin cheat',
						)
					"
				>
					+1 Festival Pyre
				</button>
				<button
					type="button"
					@click="
						buildingsStorageStore.increase(
							FrameName.BOUNTIFUL_MARKETPLACE,
							1,
							'admin cheat',
						)
					"
				>
					+1 Bountiful Marketplace
				</button>
				<button
					type="button"
					@click="
						buildingsStorageStore.increase(
							FrameName.SOLSTICE_WINDMILL,
							1,
							'admin cheat',
						)
					"
				>
					+1 Solstice Windmill
				</button>
				<button
					type="button"
					@click="
						buildingsStorageStore.increase(
							FrameName.HUNTING_CAMP,
							1,
							'admin cheat',
						)
					"
				>
					+1 Hunting Camp
				</button>
				<button
					type="button"
					@click="
						buildingsStorageStore.increase(
							FrameName.HIGHLAND_HUNTER,
							1,
							'admin cheat',
						)
					"
				>
					+1 Highland Hunter
				</button>
				<button
					type="button"
					@click="
						buildingsStorageStore.increase(
							FrameName.SHEPHERDS_LODGE,
							1,
							'admin cheat',
						)
					"
				>
					+1 Shepherd's Lodge
				</button>
				<button
					type="button"
					@click="
						buildingsStorageStore.increase(
							FrameName.HAUNTED_MANSION,
							1,
							'admin cheat',
						)
					"
				>
					+1 Haunted Mansion
				</button>
				<button
					type="button"
					@click="
						buildingsStorageStore.increase(
							FrameName.CORSAIR_SHIP,
							1,
							'admin cheat',
						)
					"
				>
					+1 Corsair Ship
				</button>
				<button
					type="button"
					@click="
						buildingsStorageStore.increase(
							FrameName.GREAT_WAREHOUSE,
							1,
							'admin cheat',
						)
					"
				>
					+1 Great Warehouse</button
				><button
					type="button"
					@click="
						buildingsStorageStore.increase(
							FrameName.APPLE_ORCHARD,
							1,
							'admin cheat',
						)
					"
				>
					+1 Apple Orchard
				</button>
				<button
					type="button"
					@click="
						buildingsStorageStore.increase(
							FrameName.FORESTER_COTTAGE,
							1,
							'admin cheat',
						)
					"
				>
					+1 Forester's Cottage
				</button>
			</div>
			<div class="buttons">
				<button type="button" @click="playRewardedAd">
					Show Rewarded Ad
				</button>
			</div>
			<div class="buttons">
				<button type="button" @click="showOffer">+ LB Offer Ad</button>
			</div>
			<div class="buttons">
				<button type="button" @click="showSpecialChestAdPopup">
					Show Special Chest Ad
				</button>
			</div>
			<div class="buttons">
				<button type="button" @click="setCustomLevel">
					🆙 Set custom level
				</button>
				<button @click="setCustomCountry">🇸🇰 Set custom country</button>
				<button type="button" @click="setOfflineTime">
					🕰️ Set offline time
				</button>
			</div>
			<div class="buttons">
				<button type="button" @click="revealMap">
					🌍 Reveal whole map
				</button>
				<button type="button" @click="resetAccount">
					🤡 Reset account
				</button>
			</div>
			<div class="buttons">
				<button type="button" @click="activateDebug">
					Active debug
				</button>
			</div>
			<div class="buttons">
				<button type="button" @click="add100SuperClickers">
					Add 100 Super Clickers
				</button>
			</div>
			<div class="buttons">
				<button type="button" @click="add102xSuperClickers">
					Add 10 2x Super Clickers
				</button>
			</div>
			<div class="buttons">
				<button type="button" @click="add105xSuperClickers">
					Add 10 5x Super Clickers
				</button>
			</div>
			<div class="buttons">
				<button type="button" @click="add100AdSkippers">
					Add 100 Ad skippers
				</button>
			</div>
			<div class="buttons">
				<button type="button" @click="showNews">Show News</button>
			</div>
			<div class="buttons">
				<button type="button" @click="showDailyReward">
					Show Daily Reward
				</button>
			</div>
			<div class="buttons">
				<button type="button" @click="resetIncomeBoost">
					Reset income boost
				</button>
			</div>
			<div class="buttons">
				<button type="button" @click="resetIncomeBoostTicks">
					Reset income boost ticks
				</button>
			</div>
			<div class="buttons">
				<button type="button" @click="addSpecialLocation">
					Add special location
				</button>
			</div>
			<div class="buttons">
				<button type="button" @click="resetDiscordRewardAndRated">
					Reset discord reward & rated
				</button>
			</div>
			<div class="buttons">
				<button type="button" @click="removeEventBuildings">
					Remove event buildings
				</button>
			</div>
			<div class="buttons">
				<button type="button" @click="tilerepo.fixRedTiles()">
					Fix red tiles
				</button>
			</div>
			<div class="buttons">
				<button type="button" @click="showLevelUp">Show levelup</button>
			</div>
			<div class="buttons">
				<button type="button" @click="spawnChestOnTile">
					Spawn chest on tile
				</button>
			</div>
			<div class="buttons">
				<button @click="clearProvision">CLR all</button>
				<button @click="activateProvision(1)">act. RP_1</button>
				<button @click="activateProvision(2)">act. RP_2</button>
				<button @click="clearDeeplinkOffer">CLR deeplink offer</button>
			</div>
			<QuestSelector />
		</div>
	</div>
</template>

<script lang="ts" setup>
import AppMainIcon from "@/components/AppMainIcon.vue";
import AppTextButton from "@/components/AppTextButton.vue";
import LevelUp from "@/components/LevelUp.vue";
import QuestSelector from "@/components/QuestSelector.vue";
import { EASTER_RARE_PICKUP_CHANCE } from "@/config/constants";
import { useEventStore } from "@/event";
import ChestRepository from "@/game/ChestRepository";
import type SettlementCastleBuildingTileEntity from "@/game/entities/buildings/SettlementCastleBuildingTileEntity";
import { FrameName } from "@/game/entities/config";
import { ResourceType } from "@/game/entities/config/resources";
import {
	MAX_SETTLEMENT_LEVEL,
	getSettlementConfigByLevel,
} from "@/game/entities/config/settlements";
import { EventUpgradeIds, UpgradeIds } from "@/game/entities/config/upgrades";
import { getUpgradeCurrentReplaceValueById } from "@/game/utils/upgrades";
import useEmitter, { EmitterEvents } from "@/hooks/useEmitter";
import useGameTicker from "@/hooks/useGameTicker";
import useSegmentManager from "@/hooks/useSegmentManager";
import useSiegeSystemRepository from "@/hooks/useSiegeSystemRepository";
import useSocketService, { EmitStores } from "@/hooks/useSocketService";
import useTileRepository from "@/hooks/useTileRepository";
import Communicator from "@/libs/AppCommunicatior";
import router from "@/router";
import useBuildingsStorageStore from "@/store/useBuildingsStorageStore";
import type { FlashNews } from "@/store/useNewsStore";
import useNewsStore from "@/store/useNewsStore";
import useOfferStore from "@/store/useOfferStore";
import {
	PopupDictionary,
	PopupType,
	usePopupStore,
} from "@/store/usePopupStore";
import useResourcesStore from "@/store/useResourcesStore";
import useSettlementsStore from "@/store/useSettlementsStore";
import useShopStore from "@/store/useShopStore";
import useUpgradesStore from "@/store/useUpgradesStore";
import useUserStore from "@/store/useUserStore";
import type { ShopItem } from "@/types/shop";
import { EventCategory, RouteNames, SkinTypes } from "@/types/ui";
import { provisionDaysInMs } from "@/utils/shop/values";
import { translate } from "@/utils/translate";
import { storeToRefs } from "pinia";
import { computed, markRaw, ref } from "vue";
import { ChestType } from "../game/entities/objects/chests";
const ticker = markRaw(useGameTicker());
const emitter = markRaw(useEmitter());
const tilerepo = markRaw(useTileRepository());
const communicator = markRaw(Communicator.getInstance());

const settlementsStore = useSettlementsStore();
const buildingsStorageStore = useBuildingsStorageStore();
const offerStore = useOfferStore();
const resourcesStore = useResourcesStore();
const { explorationSpeed } = storeToRefs(resourcesStore);
const { increase, decrease, set } = resourcesStore;

const eventStore = useEventStore();
const { grandPrizeState, attributes } = storeToRefs(eventStore);

const isOpen = ref<boolean>(false);

const activateProvision = (provision: number): void => {
	const offers = useShopStore().provisionOffers;
	if (!offers) return;
	const offer = offers.find(
		(offer: ShopItem): boolean =>
			offer.store_id === `lok_provision_${provision}`,
	);
	if (!offer) return;
	useUserStore().addProvision(
		offer.store_id,
		provisionDaysInMs(offer.store_id),
	);
};
const clearProvision = (): void => {
	useUserStore().clearProvisions();
};

const clearDeeplinkOffer = (): void => {
	const userStore = useUserStore();
	userStore.setDeeplinkWelcomeBackOfferExpires(null);
	userStore.setWelcomeBackRewardClaimed(false);
};

const clearInventory = (): void => {
	Object.keys(buildingsStorageStore.getAllBuildings()).forEach(
		(building): void => {
			buildingsStorageStore.set(
				building as FrameName,
				0,
				"admin cheat - clear inventory",
			);
		},
	);
};
const resetAllResources = (): void => {
	Object.values(ResourceType).forEach((resource: ResourceType): void => {
		if (resource === ResourceType.EXPLORATION_SPEED) return;
		set(resource, 0, "admin cheat");
	});
};

function incrementExplorationSpeed(): void {
	increase(ResourceType.EXPLORATION_SPEED, 100, "admin cheat"); // zvýš o 100
	//TODO toto je user dependent hodnota, default je 100 a navysuje sa upgradami atd, emit by mal chodit pri
	//TODO jej zmene ako naprikald update alebo ine akcie nie pri kazdom odhaleni tile
	emitter.emit(EmitterEvents.PhaserRecalculateExplorationSpeed);
}

function decrementExplorationSpeed(): void {
	if (explorationSpeed.value <= 1) return;

	decrease(ResourceType.EXPLORATION_SPEED, 100, "admin cheat"); // zmenši o 100
	//TODO toto je user dependent hodnota, default je 100 a navysuje sa upgradami atd, emit by mal chodit pri
	//TODO jej zmene ako naprikald update alebo ine akcie nie pri kazdom odhaleni tile
	emitter.emit(EmitterEvents.PhaserRecalculateExplorationSpeed);
}

const onTick = async (): Promise<void> => {
	increase(ResourceType.TICKS_TOTAL, 1, false);
	await tilerepo.onTick();
	useSiegeSystemRepository().onTick();
};

const onTick6 = async (): Promise<void> => {
	for (let i = 0; i < 6; i++) {
		await onTick();
	}
};

function activateDebug(): void {
	emitter.emit(EmitterEvents.PhaserActiveDebug);
}
const showOffer = (): void => {
	offerStore.checkAndShowOffer(true);
};

const playRewardedAd = (): void => {
	communicator.playRewardedAd();
};

const showSpecialChestAdPopup = (): void => {
	usePopupStore().showPopup({
		id: PopupDictionary.SPECIAL_CHEST_REWARD,
		type: PopupType.CHEST,
		skin: SkinTypes.LIGHT,
		width: 26,
		height: 28,
		body: JSON.stringify({
			coins: 10_0000,
			superClicker: 20_000,
			gems: 1_340,
		}),
		isPaddingless: true,
		percentageWidth: "95%",
	});
};

const setCustomLevel = async (): Promise<void> => {
	const level = +(
		prompt(
			`Enter custom level (1-${MAX_SETTLEMENT_LEVEL}):`,
			settlementsStore.mainLevel.toString(),
		) || 1
	);

	if (isNaN(level) || level < 1 || level > MAX_SETTLEMENT_LEVEL)
		return alert(
			`Invalid level. Please enter a number between 1 and ${MAX_SETTLEMENT_LEVEL}.`,
		);

	settlementsStore.setSettlementPropsByCoordinates(
		{ x: 512, y: 512 },
		{
			level,
			isQuestSkipEnabled: false,
			availableClicks:
				getSettlementConfigByLevel(level).storage.get(
					ResourceType.SETTLEMENT_CLICKS,
				) ?? 0,
			questData: {},
		},
	);

	useUserStore().setPlayerLevel(level);

	const castle = tilerepo.getTileEntityByTileCoordinates({
		x: 512,
		y: 512,
	}) as SettlementCastleBuildingTileEntity | null;
	if (castle) {
		castle.level = level;
	}

	const sm = useSegmentManager();
	sm.markSegmentAsDirtyByCoordinates({ x: 512, y: 512 });
	sm.run(true);

	// eslint-disable-next-line no-undef
	if (__APP_IS_OLIVER__)
		useUpgradesStore().increaseCurrentLevelById(UpgradeIds.quick_tool);

	try {
		await useSocketService().emitSaveRequest({
			stores: [
				EmitStores.SETTLEMENTS,
				EmitStores.USER,
				EmitStores.UPGRADES,
			],
		});
	} catch (error: unknown) {
		console.error("[AdminResourcer] Failed to persist custom level", error);
	}
};

const setCustomCountry = (): void => {
	const country = prompt(
		"Enter custom country code (e.g., US, SK, DE):",
		"SK",
	);

	if (!country || country.length !== 2) {
		return alert(
			"Invalid country code. Please enter a valid 2-letter code.",
		);
	}

	useUserStore().setCountry(country.toUpperCase());
	alert(`Country code set to ${country.toUpperCase()}`);
};

const testStoryFinish = (): void => {
	router.push({
		name: RouteNames.STORY,
		params: { chapter: "3", id: "1" },
	});
};
const testStoryStart = (): void => {
	router.push({
		name: RouteNames.STORY,
		params: { chapter: "1", id: "1" },
	});
};

const setOfflineTime = (): void => {
	const offlineTime = +(
		prompt(
			"Enter offline time in seconds (default is 20 minutes = 1200 seconds):",
			"1200",
		) ?? 0
	);

	if (isNaN(offlineTime) || offlineTime <= 0) {
		alert("Invalid input. Please enter a valid number.");
		return;
	}

	location.href = `/?offline-time=${offlineTime}&disable-tutorial`;
};

const add100SuperClickers = (): void => {
	resourcesStore.increase(ResourceType.SUPER_CLICKER, 100, "admin cheat");
};

const add102xSuperClickers = (): void => {
	const resourcesStore = useResourcesStore();
	resourcesStore.increase(ResourceType.CLICKER_2, 10, "admin cheat");
};
const add105xSuperClickers = (): void => {
	resourcesStore.increase(ResourceType.CLICKER_5, 10, "admin cheat");
};

const add100AdSkippers = (): void => {
	resourcesStore.increase(ResourceType.AD_SKIPPER, 100, "admin cheat");
};

const showNews = (): void => {
	const newsStore = useNewsStore();
	const now = new Date(Date.now());
	let testingNews: FlashNews = {
		id: "testing-news-1",
		title: "Lorem ipsum dolor sit amet, consectetur adipiscing",
		message:
			"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
		created_at: now,
		start_date: now,
		end_date: now,
	}; // NOTE: fallback for local testing

	if (newsStore.news && newsStore.news.length > 0) {
		testingNews = newsStore.news[0];
	}

	const popupStore = usePopupStore();
	popupStore.showPopup({
		id: PopupDictionary.NEWS,
		type: PopupType.NEWS,
		heading: translate("ui.news"),
		body: {
			title: testingNews.title,
			text: testingNews.message,
			date: new Date(testingNews.created_at),
		},
		skin: SkinTypes.DARK,
		maxHeight: 42,
		width: 22,
		isPaddingless: true,
	});
};

const showDailyReward = (): void => {
	if (
		attributes.value.type &&
		[EventCategory.SOLAR, EventCategory.PIRATES].includes(
			attributes.value.type,
		)
	) {
		let nextGPState: {
			gemsEarnedToday?: number;
			chestKeysEarnedToday?: number;
			lastDailyFreePickedDaysAfterReg?: number;
			chestKeys?: number;
		} = {
			gemsEarnedToday: grandPrizeState.value?.gemsEarnedToday,
			chestKeysEarnedToday: grandPrizeState.value?.chestKeysEarnedToday,
		};
		nextGPState = {
			...nextGPState,
			lastDailyFreePickedDaysAfterReg: 0,
		};
		eventStore.mergeGrandPrizeState(nextGPState);
	}

	const popupStore = usePopupStore();
	popupStore.showPopup({
		id: PopupDictionary.DAILY_BONUS,
		type: PopupType.DAILY_REWARD,
		heading: translate("ui.daily_bonus"),
		skin: SkinTypes.LIGHT,
		maxHeight: 24,
		width: 22.5,
		isPaddingless: true,
	});
};

const resetIncomeBoost = (): void => {
	const userStore = useUserStore();
	userStore.setIncomeBoostsUsedToday(0);
};
const resetIncomeBoostTicks = (): void => {
	const userStore = useUserStore();
	userStore.setIncomeBoostTicksRemaining(0);
};
const addSpecialLocation = (): void => {
	const emitter = useEmitter();
	emitter.emit(EmitterEvents.NewSpecialLocation);
};
const revealMap = (): void => {
	// TODO: Tu este token chyba a kvoli tomu to nefunguje na QA.
	location.href = "/?reveal-map&disable-tutorial&enable-web";
};

const resetAccount = (): void => {
	if (!confirm("Are you sure you want to reset your account?")) return;

	localStorage.clear();
	sessionStorage.clear();

	// https://stackoverflow.com/a/27374365
	document.cookie.split(";").forEach((name: string): void => {
		document.cookie = name
			.replace(/^ +/, "")
			.replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
	});

	location.reload();
};

const resetDiscordRewardAndRated = (): void => {
	const userStore = useUserStore();
	userStore.setDiscordRewardClaimed(false);
	userStore.setAppRated(false);
	userStore.setAppRatedGemRewardClaimed(false);
	alert("Discord reward and rated status have been reset.");
};
const goldenEggsSpawn = computed(() => {
	const rarePickupChance =
		EASTER_RARE_PICKUP_CHANCE +
		getUpgradeCurrentReplaceValueById(EventUpgradeIds.ea_golden_chance) +
		getUpgradeCurrentReplaceValueById(EventUpgradeIds.ea_golden_jackpot) +
		getUpgradeCurrentReplaceValueById(
			EventUpgradeIds.ea_eastertide_special2,
		);
	return rarePickupChance * 100;
});

const removeEventBuildings = (): void => {
	tilerepo.removeEventBuildings();
};

const showLevelUp = (): void => {
	usePopupStore().showPopup({
		id: PopupDictionary.LEVEL_UP,
		type: PopupType.INFO,
		width: 24,
		height: "auto",
		isPaddingless: true,
		skin: SkinTypes.TRANSPARENT,
		scaleDelay: 400,
		component: markRaw(LevelUp),
	});
};

const spawnChestOnTile = (): void => {
	const tileIndex = +(prompt("Enter tileIndex:") || 1);
	const tile = tilerepo.getTileEntityByTileIndex(tileIndex);
	if (tile === null) return;
	ChestRepository.getInstance().tryGenerateChest(ChestType.EXPLORE, {
		x: tile?.x,
		y: tile?.y,
	});
};
</script>

<style lang="scss" scoped>
.admin-resourcer {
	width: 10rem;

	&__content {
		display: flex;
		position: absolute;
		left: 0;
		flex-direction: column;
		gap: 0.25rem;
		transform: translateX(-100%);
		transition: transform 0.2s ease-in-out;
		margin-top: 0.25rem;
		background: #333;
		padding: 0.375rem;
		width: 100%;
		max-height: 15rem;
		overflow-y: auto;
		pointer-events: auto;

		&--open {
			transform: translateX(0);
		}
		.stats {
			display: flex;
			flex-direction: column;
			flex-wrap: wrap;
			gap: 0.25rem;
			color: white;
		}
		.buttons {
			display: flex;
			flex-wrap: wrap;
			gap: 0.25rem;
		}

		button {
			@include flex-row-center;
			flex: 1 1 auto;
			gap: 0.25rem;

			span {
				padding-bottom: 0.25rem;
			}
		}
	}

	.text-button {
		width: 8rem;
	}
}
</style>
